import { render, staticRenderFns } from "./productClassInfo2.vue?vue&type=template&id=9ef2ceb0&scoped=true&"
import script from "./productClassInfo2.vue?vue&type=script&lang=js&"
export * from "./productClassInfo2.vue?vue&type=script&lang=js&"
import style0 from "./productClassInfo2.vue?vue&type=style&index=0&id=9ef2ceb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef2ceb0",
  null
  
)

export default component.exports